import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS } from 'react-scroll'
import { Link } from 'react-router-dom'

export const Nav = styled.nav`
    background:#111221;
    height:5rem;
    margin-top:0px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:1rem;
    position: sticky;
    top:0;
    z-index:10;
`;
export const NavbarContainer = styled.div`
    display:flex;
    justify-content: space-between;
    height:80px;
    z-index:1;
    width:100%;
    padding: 0 15px;
    max-width:1800px;
    @media screen and (max-width:1460px){
        padding: 0 25px;
    }
`;
export const NavLogo = styled(LinkR)`
     color:#000;
     justify-self:flex-start;
     cursor:pointer;
     font-size:1.5rem;
     display:flex;
     align-items:center;
     margin-left:0px;
     font-weight:bold;
     text-decoration:none;
     @media screen and (max-width:1460px){
         width:10rem;
     }
`;
export const MoblieIcon = styled.div`
    display:none;
    @media screen and (max-width:950px){
        display:block;
        position:absolute;
        top:0;
        right:0;
        transform: translate(-100%, 60%);
        font-size:1.8rem;
        cursor:pointer;
        color:#E8175D;
    }
`;
export const NavMenu = styled.ul`
    display:flex;
    align-items:center;
    list-style:none;
    text-align:center;
    margin-right:-22px;
    @media screen and (max-width:950px){
        display:none;
    }
`;

export const NavItem = styled.li`
    height:80px;
`;
export const NavLinks = styled(LinkS)`
    color:#E8175D;
    font-size:1.3rem;
    font-weight:inherit !important;
    display:flex;
    align-items:center;
    text-decoration:none;
    padding: 0 1rem;
    height:100%;
    cursor:pointer;
    transition:0.2s ease-in-out;
    :hover{
        color:#fff;
    }
    &.active{
        color:#fff;
    }
`;

export const NavLinkusa = styled(Link)`
    color:#000;
    font-weight:bold;
    display:flex;
    align-items:center;
    text-decoration:none;
    padding: 0 1rem;
    height:100%;
    cursor:pointer;
    transition:0.2s ease-in-out;
    :hover{
        color:#f7ba42;
    }
    &.active{
        border-bottom: 3px solid #000;
    }
`;
export const Logo = styled.img`
    width:50% !important;
    object-fit:cover;
    @media screen and (max-width:1460px){
        width: 80% !important;
    }
    @media screen and (max-width:768px){
        width:25% !important;
    }
    @media screen and (max-width:600px){
        width: 80% !important;
    }
`;